import { LineItem } from '@commerce/types'
import { FileURL, ProductVariant } from '../../types'
import isEqual from 'lodash/isEqual'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'

export function checkAndRetainReorderFieldIfNeeded(
  existingItem: LineItem,
  selection: ProductVariant,
  filesUrls: FileURL[],
  // eslint-disable-next-line camelcase
  customSelectionOption: { option_value: string; option_id: number }[]
) {
  const existingOptions = existingItem.options as unknown as {
    name: string
    nameId: number
    value: any
    valueId: number
  }[]

  // Loop over and check the difference to see whether we should keep reorder option
  const diff = existingOptions
    .map((option) => {
      if (selection[option.name.toLowerCase()] !== option.value) {
        return {
          name: option.name.toLowerCase(),
          value: selection[option.name.toLowerCase()],
        }
      }

      return null
    })
    .filter(Boolean)
    .filter(
      (option) =>
        option.name.toLowerCase() !== 'reorder' &&
        option.name.toLowerCase() !== 'customizations'
    )

  // Extract customizations
  const existingCustomizations = existingOptions.find(
    (option) => option.name.toLowerCase() === 'customizations'
  )

  let existingFilesUrls
  try {
    existingFilesUrls = JSON.parse(
      existingCustomizations?.value || '{}'
    )?.filesUrls
  } catch {
    const existingCustomizationValue = existingCustomizations?.value
    existingFilesUrls = existingCustomizationValue?.filesUrls
  }

  const sameCustomizations = isEqual(
    sortBy(existingFilesUrls),
    sortBy(filesUrls)
  )

  // Should contain only quantity
  if (
    (diff.length === 0 || // No change
      (diff.length === 1 && diff[0].name === 'quantity')) && // Or just quantity
    !isEmpty(existingCustomizations) &&
    sameCustomizations
  ) {
    customSelectionOption.push(
      ...existingOptions
        .filter((option) => option.name.toLowerCase() === 'reorder')
        .map((option) => ({
          option_id: option.nameId,
          option_value: option.value,
        }))
    )
  }
}
